import momentJalaali from "jalali-moment";

function charachterTranslate(char: string) {
    switch (char) {
        case "۰":
            return 0;
        case "۱":
            return 1;
        case "۲":
            return 2;
        case "۳":
            return 3;
        case "۴":
            return 4;
        case "۵":
            return 5;
        case "۶":
            return 6;
        case "۷":
            return 7;
        case "۸":
            return 8;
        case "۹":
            return 9;
        default:
            return "";
    }
}

export const toEnglishNum = (num: string | number) => {
    const parts = num.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const newNum = parts.join(".").toString().trim();

    const len = newNum?.length;
    let res = "";

    for (let i = 0; i < len; i++) res += charachterTranslate(newNum.charAt(i));

    return res;
};

export const toEnglishDate = (num: string) => {
    const perNum = num.includes("-") ? num.split("-") : num.split("/");
    const newNum = [
        toEnglishNum(perNum[0]),
        toEnglishNum(perNum[1]),
        toEnglishNum(perNum[2]),
    ];
    return newNum.join("-");
};

export const toPersianNum = (
    num: number | string | undefined,
    withoutComma?: boolean
) => {
    if (num) {
        const parts = num.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const newNum = parts.join(".").toString().trim();

        let i = 0,
            len = newNum.length,
            res = "",
            pos,
            persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

        for (; i < len; i++)
            if ((pos = persianNumbers[+newNum.charAt(i)])) res += pos;
            else res += newNum.charAt(i);

        return withoutComma
            ? res.toString().split(",").join("").toString().trim()
            : res;
    }
    return "۰";
};
export const changeNumbersToPersianInStr = (text: string) => {
    const reverseNum = text.replace(/\d+/g, (d: any) =>
        d.split("").reverse().join("")
    );
    const replaceWithPer = reverseNum.replace(
        /\d/g,
        (d: any) => "۰۱۲۳۴۵۶۷۸۹"[d]
    );
    return replaceWithPer;
};

export const persianToEnglishNumber = (
    inputNumber: string | number,
    separator = ""
) => {
    const persianNumbers: RegExp[] = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
    ];
    const arabicNumbers: RegExp[] = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
    ];

    let arabicPersianNumber = inputNumber;
    if (separator !== "") {
        arabicPersianNumber = inputNumber
            ?.toString()
            .replace(new RegExp(separator, "g"), "");
    }

    let englishNumber = arabicPersianNumber.toString();

    for (let i = 0; i < 10; i++) {
        englishNumber = englishNumber.replace(persianNumbers[i], i.toString());
        englishNumber = englishNumber.replace(arabicNumbers[i], i.toString());
    }
    return englishNumber;
};

export const todayDate = () => {
    const now = momentJalaali();
    return {
        day: toPersianNum(now.locale("fa").format("jDD")),
        weekDay: now.locale("fa").format("dddd"),
        month: now.locale("fa").format("jMMMM"),
    };
};

export const convertPersianDateToGregorian = (persianDate: string) => {
    const shamsiMoment = momentJalaali(persianDate, "jYYYY/jM/jD");
    const gregorianDate = shamsiMoment.format("YYYY-MM-DD");
    return gregorianDate;
};
export const convertGregorianDateToPersian = (
    gregorian: string,
    format?: string
) => {
    const gregorianMoment = momentJalaali(gregorian, "YYYY/MM/DD");
    const shamsiDate = gregorianMoment.format(format ?? "jYYYY-jM-jD");
    return shamsiDate;
};

export const currentTime = () => {
    const date = new Date();
    let hh: string | number = date.getHours();
    let mm: string | number = date.getMinutes();
    let ss: string | number = date.getSeconds();
    let session = "AM";

    if (hh === 0) {
        hh = 12;
    }
    if (hh > 12) {
        hh = hh - 12;
        session = "PM";
    }

    hh = hh < 10 ? "0" + hh : hh;
    mm = mm < 10 ? "0" + mm : mm;
    ss = ss < 10 ? "0" + ss : ss;

    const time = hh + ":" + mm + ":" + ss + " " + session;

    setTimeout(function () {
        currentTime();
    }, 1000);

    return time;
};

export const removeCamma = (value: any) => {
    const copy = value;
    return copy?.toString().replace(/,/g, "");
};

export const addCamma = (value: any) => {
    const commas = value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return commas;
};

export const changePrantesesDirection = (text: string) => {
    const newTextReplace = text.replace(/\(/g, "}").replace(/\)/g, "{");
    const newText = newTextReplace.replace(/\}/g, ")").replace(/\{/g, "(");
    return newText;
};

const regex = (regex: RegExp, value: string | undefined) =>
    value ? regex.test(value) : false;

export const validator = {
    mobileNumberHasZero: (value: string | undefined) =>
        regex(/^(09)[0-9]{9}$/, value),
};

export const DecodeJWT = (token: string) => {
    if (token) {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map(function (c) {
                    return (
                        "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
                    );
                })
                .join("")
        );

        return JSON.parse(jsonPayload);
    }
    return null;
};

export const generateExcelColumnName = (index: number) => {
    let name = "";
    while (index >= 0) {
        name = String.fromCharCode(65 + (index % 26)) + name;
        index = Math.floor(index / 26) - 1;
    }
    return name;
};

export const groupBy = function (array: any, key: any) {
    return array?.reduce(function (rv: any, x: any) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export const convertDigits = (inputNumber: string | number, separator = "") => {
    const id: RegExp[] = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];

    let arabicPersianNumber = inputNumber;
    if (separator !== "") {
        arabicPersianNumber = inputNumber?.toString().replace(new RegExp(separator, "g"), "");
    }

    let englishNumber = arabicPersianNumber.toString();

    for (let i = 0; i < 10; i++) {
        englishNumber = englishNumber.replace(id[i], i.toString());
    }
    return englishNumber;
};